import { Component, OnInit, Input } from '@angular/core';
import { ErrorType } from '../../../interfaces/exception';

@Component({
  selector: 'app-error-component',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  @Input() errorType: ErrorType = ErrorType.ERROR_500;

  title: string = '';
  description: string = '';
  imageUrl: string = '';

  constructor() { }

  ngOnInit(): void {
    this.setPageInfo(this.errorType);
  }

  private setPageInfo(errorType: ErrorType): void {
    switch (errorType) {
      case ErrorType.ERROR_404:
        this.title = '페이지를\n찾을 수 없습니다';
        this.description = '페이지가 사라졌거나 다른 주소로 이동했습니다.\n주소를 다시 한번 확인해 주세요.';
        this.imageUrl = '../../assets/icons/icon-error-404.png';
        break;
      case ErrorType.ERROR_500:
        this.title = '서비스 접속이\n원활하지 않습니다';
        this.description = '현재 서비스와 연결할 수 없습니다.\n문제 해결을 위해 노력하고 있으니 불편하시더라도\n잠시 후에 다시 시도해 주세요.';
        this.imageUrl = '../../assets/icons/icon-error-500.png';
        break;
      case ErrorType.SYSTEM_CHECK:
        this.title = '서비스 점검이\n진행중입니다';
        this.description = '현재 서비스 점검이 진행중입니다.\n잠시 후에 다시 이용해 주세요.';
        this.imageUrl = '../../assets/icons/icon-system-check.png';
        break;
      default:
        this.title = '페이지를\n찾을 수 없습니다';
        this.description = '페이지가 사라졌거나 다른 주소로 이동했습니다.\n주소를 다시 한번 확인해 주세요.';
        this.imageUrl = '../../assets/icons/icon-error-404.png';
        break;
    }
  }

}
